module.exports = __webpack_public_path__ + "static/media/FDA_fast_track.7d6f78bd.jpg";